import $ from "jquery";
import joint from "jointjs";
import styles from "./JointProjectModule.css";


joint.shapes.html = {};
joint.shapes.html.Element = joint.shapes.devs.Model.extend({
  defaults: joint.util.deepSupplement({
    type: 'html.Element',
    attrs: {
      rect: {
        stroke: 'none',
        'fill-opacity': 0,
        width: 200,
        height: 80
      },
      text: {
        fill: "blue"
      }
    },
    inPorts: [],
    outPorts: [],
    ports: {
      groups: {
        'in': {
          position: {
            name: "top"
          },
          attrs: {
            ".port-label": {
              fill: "#000"
            },
            '.port-body': {
              fill: '#fff',
              stroke: "#000",
              r: 6,
              magnet: true
            }
          },
          label: {
            position: {
              name: "top",
              args: {
                x: -40,
                y: -15
              }
            }
          },
          // z: 0
        },
        'out': {
          position: {
            name: "bottom"
          },
          attrs: {
            ".port-label": {
              fill: "#000"
            },
            '.port-body': {
              fill: '#fff',
              stroke: "#000",
              r: 6,
              magnet: true
            }
          },
          label: {
            position: {
              name: "bottom",
              args: {
                x: -40,
                y: 15
              }
            }
          },
          // z: 0
        }
      }
    }
  }, joint.shapes.basic.Rect.prototype.defaults)
});

joint.shapes.html.ElementView = joint.dia.ElementView.extend({
  template: [
    '<div class="html-joint-project-module-view">',
    // '<button class="delete">x</button>',
    '<div class="dataset-layout">',
    '<img src="" class="icon" alt="logo" height="20" width="20"/>',
    '<label>good</label>',
    '</div>',
    '<div id="status" class="status-info"/>',
    '</div>'
  ].join(''),

  initialize: function() {
    _.bindAll(this, 'updateBox');
    joint.dia.ElementView.prototype.initialize.apply(this, arguments);
    this.$box = $(_.template(this.template)());
    this.$box.find('.delete').on('click', _.bind(this.model.remove, this.model));
    this.model.on('change', this.updateBox, this);
    this.model.on('remove', this.removeBox, this);
    this.updateBox();
  },

  render: function() {
    joint.dia.ElementView.prototype.render.apply(this, arguments);
    this.paper.$el.prepend(this.$box);
    this.updateBox();
    return this;
  },

  updateBox: function() {
    if (!this.paper) return;
    let bbox = this.model.getBBox();
    const scale = joint.V(this.paper.viewport).scale();
    console.debug("JointProjectModule updateBox scale:", bbox.width * scale.sx, bbox.height * scale.sy);
    this.$box.find("img").attr("src", this.model.get("icon"));
    this.$box.find('label').text(this.model.get('label'));
    this.$box.find("#status").attr("class", this.model.get("status"));
    this.model.set("inPorts", this.model.get("inPorts"));
    this.model.set("outPorts", this.model.get("outPorts"));
    this.$box.css({
      width: bbox.width,
      height: bbox.height,
      left: bbox.x * scale.sx,
      top: bbox.y * scale.sy,
      transform: `scale(${scale.sx},${scale.sy})`,//'rotate(' + (this.model.get('angle') || 0) + 'deg)'
      transformOrigin: '0 0',
    });
  },

  removeBox: function(evt) {
    console.debug("JointProjectModule removeBox:", evt.attributes.id, this.paper.model);
    this.$box.remove();
  }
});
